module.exports = __webpack_public_path__ + "img/filter-circle-fill.50901536.svg";